import {POST_NEW_SECTION} from '../actiontypes';
import {GroupSectionsUrl} from '../apiUrls';

export const createGroupSection = (engagementId, payload) => {
	const url = GroupSectionsUrl(engagementId);
	return {
		type: POST_NEW_SECTION,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload
			}
		},
		...payload
	};
};
